module.exports = __webpack_public_path__ + "img/loading.62f1f343.png";